import type { IconSvgObject } from './types';

const Grid2X2PlusIcon: IconSvgObject = [
  ["path", { d: "M11.5 20.5H4.5C3.39543 20.5 2.5 19.6046 2.5 18.5V4.5C2.5 3.39543 3.39543 2.5 4.5 2.5H18.5C19.6046 2.5 20.5 3.39543 20.5 4.5V11.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.5 2.5V20.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M20.5009 11.4922H2.50586", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M18.495 15.5V21.5M21.5 18.495L15.5 18.495", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Grid2X2PlusIcon;
